/* Speed Junkies HQ - VIP membership "one per account" guard.

   Layers (strongest first):
     1. Shopify Subscriptions app - the membership is a subscription product, so
        checkout requires a customer account.
     2. Customer tag  vip_active  - written from the live subscription contract
        status. Liquid renders the blocked state server side, so it is not a
        CSS-only trick.
     3. This file - clamps every /cart/add, /cart/change and /cart/update call
        (fetch, XHR and plain form posts) so the membership can never exceed
        quantity 1 and can never be added twice.
     4. A cart reconcile pass that forces the line back to 1 if anything slips
        through.

   Config is rendered by snippets/sj-vip-guard.liquid.
*/
(function () {
  'use strict';
  if (window.__sjVipGuard) return;
  window.__sjVipGuard = true;

  var cfgEl = document.getElementById('sj-vip-guard-config');
  var CFG = {};
  try { CFG = JSON.parse((cfgEl && cfgEl.textContent) || '{}'); } catch (e) { CFG = {}; }
  if (!CFG.handle) return;

  var IDS = {};
  (CFG.variantIds || []).forEach(function (id) { IDS[String(id)] = true; });

  var STATE = {
    active: !!CFG.active,
    inCart: parseInt(CFG.inCart, 10) || 0,
    loggedIn: !!CFG.loggedIn
  };

  var MSG = CFG.messages || {};
  var LIMIT_MSG = MSG.limit || 'Only one active VIP membership is allowed per customer account.';
  var ACTIVE_MSG = MSG.active || 'Only one active VIP membership is allowed per customer account.';

  function isVipId(v) { return v != null && IDS[String(v)] === true; }

  /* ------------------------------------------------ toast ------------ */
  function toast(text) {
    var el = document.querySelector('[data-sj-vip-toast]');
    if (!el) {
      el = document.createElement('div');
      el.className = 'sj-vip-toast';
      el.setAttribute('data-sj-vip-toast', '');
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
    }
    el.textContent = text;
    el.classList.add('is-on');
    clearTimeout(el.__t);
    el.__t = setTimeout(function () { el.classList.remove('is-on'); }, 5200);
  }
  window.SJVipNotice = toast;

  /* --------------------------------------- decision for one add ------ */
  /* returns { allow:bool, qty:number, reason:string } */
  function decideAdd(qty) {
    var want = parseInt(qty, 10);
    if (isNaN(want) || want < 1) want = 1;
    if (STATE.active) return { allow: false, qty: 0, reason: ACTIVE_MSG };
    if (STATE.inCart >= 1) return { allow: false, qty: 0, reason: LIMIT_MSG };
    return { allow: true, qty: 1, reason: want > 1 ? LIMIT_MSG : '' };
  }

  function decideQty(qty) {
    var want = parseInt(qty, 10);
    if (isNaN(want) || want < 0) want = 0;
    if (want <= 1) return { qty: want, reason: '' };
    return { qty: 1, reason: LIMIT_MSG };
  }

  function refuse(message) {
    var body = JSON.stringify({
      status: 422,
      message: 'Cart Error',
      description: message,
      errors: { quantity: [message] }
    });
    toast(message);
    document.dispatchEvent(new CustomEvent('sj:vip:blocked', { detail: { message: message } }));
    return new Response(body, {
      status: 422,
      headers: { 'Content-Type': 'application/json' }
    });
  }

  /* -------------------------------------------- body inspection ------ */
  function readBody(body) {
    /* -> { kind, get(name), set(name,val), items[], out() } or null */
    if (!body) return null;

    if (typeof body === 'string') {
      var trimmed = body.trim();
      if (trimmed.charAt(0) === '{' || trimmed.charAt(0) === '[') {
        try { return { kind: 'json', data: JSON.parse(trimmed) }; } catch (e) { return null; }
      }
      return { kind: 'urlenc', data: new URLSearchParams(body) };
    }
    if (typeof FormData !== 'undefined' && body instanceof FormData) return { kind: 'formdata', data: body };
    if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) return { kind: 'urlenc', data: body };
    if (typeof body === 'object') return { kind: 'json', data: body };
    return null;
  }

  function serialise(parsed) {
    if (!parsed) return null;
    if (parsed.kind === 'json') return JSON.stringify(parsed.data);
    if (parsed.kind === 'urlenc') return parsed.data.toString();
    return parsed.data; /* FormData is mutated in place */
  }

  /* Handles /cart/add payloads in all the shapes Shopify accepts. */
  function inspectAdd(parsed) {
    if (!parsed) return { touched: false };

    if (parsed.kind === 'json') {
      var d = parsed.data;
      if (Array.isArray(d.items)) {
        var kept = [], blockedMsg = '';
        d.items.forEach(function (it) {
          if (!isVipId(it.id)) { kept.push(it); return; }
          var v = decideAdd(it.quantity);
          if (!v.allow) { blockedMsg = v.reason; return; }
          if (v.reason) blockedMsg = v.reason;
          it.quantity = 1;
          kept.push(it);
        });
        if (kept.length !== d.items.length || blockedMsg) {
          d.items = kept;
          return { touched: true, empty: kept.length === 0, message: blockedMsg };
        }
        return { touched: false };
      }
      if (isVipId(d.id)) {
        var r = decideAdd(d.quantity);
        if (!r.allow) return { touched: true, empty: true, message: r.reason };
        d.quantity = 1;
        return { touched: true, empty: false, message: r.reason };
      }
      return { touched: false };
    }

    /* urlencoded / FormData */
    var p = parsed.data;
    var id = p.get('id');
    if (!isVipId(id)) return { touched: false };
    var res = decideAdd(p.get('quantity'));
    if (!res.allow) return { touched: true, empty: true, message: res.reason };
    p.set('quantity', '1');
    return { touched: true, empty: false, message: res.reason };
  }

  function inspectChange(parsed) {
    if (!parsed) return { touched: false };

    if (parsed.kind === 'json') {
      var d = parsed.data;
      if (d.updates && typeof d.updates === 'object') {
        var msg = '';
        if (Array.isArray(d.updates)) {
          /* positional array - resolve against the rendered cart */
          var order = CFG.cartLineVariants || [];
          d.updates.forEach(function (q, i) {
            if (isVipId(order[i])) {
              var v = decideQty(q);
              if (v.qty !== q) { d.updates[i] = v.qty; msg = v.reason; }
            }
          });
        } else {
          Object.keys(d.updates).forEach(function (k) {
            if (isVipId(k)) {
              var v = decideQty(d.updates[k]);
              if (v.qty !== d.updates[k]) { d.updates[k] = v.qty; msg = v.reason; }
            }
          });
        }
        return msg ? { touched: true, empty: false, message: msg } : { touched: false };
      }
      if (isVipId(d.id) || isVipId(lineVariant(d.line))) {
        var c = decideQty(d.quantity);
        if (c.qty !== d.quantity) { d.quantity = c.qty; return { touched: true, empty: false, message: c.reason }; }
      }
      return { touched: false };
    }

    var p = parsed.data;
    var id = p.get('id');
    var line = p.get('line');
    if (!isVipId(id) && !isVipId(lineVariant(line))) return { touched: false };
    var r = decideQty(p.get('quantity'));
    if (String(r.qty) !== String(p.get('quantity'))) {
      p.set('quantity', String(r.qty));
      return { touched: true, empty: false, message: r.reason };
    }
    return { touched: false };
  }

  function lineVariant(line) {
    var n = parseInt(line, 10);
    if (isNaN(n) || n < 1) return null;
    var order = CFG.cartLineVariants || [];
    return order[n - 1];
  }

  function isCartUrl(url, what) {
    if (!url) return false;
    var u = String(url);
    return u.indexOf('/cart/' + what) > -1;
  }

  /* -------------------------------------------------- fetch ---------- */
  var nativeFetch = window.fetch;

  /* ------------------------------------------------------------------
     LIVE gate (added to close the duplicate-membership hole).

     The original decision used STATE.inCart, which is only a snapshot
     taken when the page was rendered. Two quick taps on Join VIP - or any
     add made from a tab that had been left open - both saw inCart = 0, so
     both were allowed and Shopify merged them into a single line of
     quantity 2. Likewise a customer who had just subscribed was not yet
     carrying the vip_active tag, so nothing stopped a second membership.

     Every add that touches the VIP variant is now queued one at a time and
     re-checked against the live cart AND the live subscription contract
     before it is allowed through.
     ------------------------------------------------------------------ */
  var gateChain = Promise.resolve();

  function touchesVip(parsed) {
    if (!parsed) return false;
    try {
      if (parsed.kind === 'json') {
        var d = parsed.data;
        if (Array.isArray(d.items)) {
          for (var i = 0; i < d.items.length; i++) { if (isVipId(d.items[i].id)) return true; }
          return false;
        }
        return isVipId(d.id);
      }
      return isVipId(parsed.data.get('id'));
    } catch (e) { return false; }
  }

  /* Refresh STATE.inCart from the cart Shopify actually holds right now. */
  function readLiveCart() {
    return nativeFetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var order = [], total = 0;
        (cart.items || []).forEach(function (it) {
          order.push(it.variant_id);
          if (isVipId(it.variant_id) || it.handle === CFG.handle) total += it.quantity;
        });
        CFG.cartLineVariants = order;
        STATE.inCart = total;
        return cart;
      })
      .catch(function () { return null; });
  }

  /* The SpeedjunkiesHQ Manager app knows about the subscription contract
     immediately, while the vip_active customer tag can lag behind it. Ask
     the app directly so a brand new member cannot slip a second membership
     through during that gap. Read only - nothing here changes app data. */
  var membershipAt = 0;
  function readLiveMembership(force) {
    if (!CFG.loggedIn) return Promise.resolve(null);
    var now = Date.now();
    if (!force && membershipAt && (now - membershipAt) < 30000) return Promise.resolve(null);
    membershipAt = now;
    var url = '/apps/api/dashboard';
    if (CFG.customerId) url += '?customerId=' + encodeURIComponent(CFG.customerId);
    return nativeFetch(url, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        var m = data && data.membership;
        if (m && m.active === true) {
          STATE.active = true;
          try { scan(document); } catch (e) {}
        }
        return m;
      })
      .catch(function () { return null; });
  }
  window.__sjVipCheckMembership = readLiveMembership;

  if (typeof nativeFetch === 'function') {
    window.fetch = function (input, init) {
      try {
        var url = (typeof input === 'string') ? input : (input && input.url) || '';
        var opts = init || {};
        var method = String(opts.method || (input && input.method) || 'GET').toUpperCase();

        /* VIP adds go through the serialised live gate. */
        if (method === 'POST' && isCartUrl(url, 'add') && touchesVip(readBody(opts.body))) {
          var self = this;
          var args = arguments;
          var run = function () {
            return Promise.all([readLiveCart(), readLiveMembership(true)]).then(function () {
              var parsed = readBody(opts.body);
              var res = inspectAdd(parsed);
              if (res.touched) {
                if (res.empty) return refuse(res.message || LIMIT_MSG);
                if (res.message) toast(res.message);
                var next = {};
                for (var k in opts) next[k] = opts[k];
                next.body = serialise(parsed);
                return nativeFetch.call(self, input, next).then(afterCart);
              }
              return nativeFetch.apply(self, args).then(afterCart);
            });
          };
          var p = gateChain.then(run, run);
          gateChain = p.catch(function () {});
          return p;
        }

        if (method === 'POST' && (isCartUrl(url, 'add') || isCartUrl(url, 'change') || isCartUrl(url, 'update'))) {
          var parsed = readBody(opts.body);
          if (parsed) {
            var res = isCartUrl(url, 'add') ? inspectAdd(parsed) : inspectChange(parsed);
            if (res.touched) {
              if (res.empty) return Promise.resolve(refuse(res.message || LIMIT_MSG));
              if (res.message) toast(res.message);
              var next = {};
              for (var k in opts) next[k] = opts[k];
              next.body = serialise(parsed);
              return nativeFetch.call(this, input, next).then(afterCart);
            }
          }
        }
        if (method === 'POST' && isCartUrl(url, '')) {
          return nativeFetch.apply(this, arguments).then(afterCart);
        }
      } catch (e) { /* never break the cart */ }
      return nativeFetch.apply(this, arguments);
    };
  }

  function afterCart(r) { setTimeout(syncFromCart, 250); return r; }

  /* ---------------------------------------------------- XHR ---------- */
  var XO = window.XMLHttpRequest && window.XMLHttpRequest.prototype;
  if (XO && XO.open && XO.send) {
    var open0 = XO.open, send0 = XO.send;
    XO.open = function (m, u) { this.__sjM = String(m || '').toUpperCase(); this.__sjU = String(u || ''); return open0.apply(this, arguments); };
    XO.send = function (body) {
      try {
        if (this.__sjM === 'POST' && (isCartUrl(this.__sjU, 'add') || isCartUrl(this.__sjU, 'change') || isCartUrl(this.__sjU, 'update'))) {
          var parsed = readBody(body);
          if (parsed) {
            var res = isCartUrl(this.__sjU, 'add') ? inspectAdd(parsed) : inspectChange(parsed);
            if (res.touched) {
              if (res.empty) { toast(res.message || LIMIT_MSG); this.abort(); return; }
              if (res.message) toast(res.message);
              arguments[0] = serialise(parsed);
              return send0.call(this, arguments[0]);
            }
          }
        }
      } catch (e) {}
      return send0.apply(this, arguments);
    };
  }

  /* --------------------------------------------- plain form post ----- */
  document.addEventListener('submit', function (ev) {
    var form = ev.target;
    if (!form || !form.getAttribute) return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart') === -1) return;

    var idField = form.querySelector('[name="id"]');
    if (!idField || !isVipId(idField.value)) return;

    var qtyField = form.querySelector('[name="quantity"]');
    var d = decideAdd(qtyField ? qtyField.value : 1);
    if (!d.allow) {
      ev.preventDefault();
      ev.stopPropagation();
      toast(d.reason);
      return;
    }
    if (qtyField) qtyField.value = '1';
  }, true);

  /* --------------------------------------------- DOM presentation ---- */
  function markButton(btn) {
    if (!btn || btn.__sjVip) return;
    btn.__sjVip = true;
    btn.setAttribute('data-sj-vip-blocked', 'true');
    btn.setAttribute('aria-disabled', 'true');
    btn.disabled = true;
    var label = btn.querySelector('[data-sj-label]') || btn.querySelector('.button-text') || btn;
    var txt = MSG.buttonActive || 'VIP MEMBERSHIP ACTIVE';
    if (btn.__sjOrigLabel == null) btn.__sjOrigLabel = label.textContent;
    btn.__sjLabelEl = label;
    if (label.textContent.trim() !== txt) label.textContent = txt;
  }

  function unmarkButton(btn) {
    if (!btn || !btn.__sjVip) return;
    btn.__sjVip = false;
    btn.removeAttribute('data-sj-vip-blocked');
    btn.removeAttribute('aria-disabled');
    btn.disabled = false;
    if (btn.__sjLabelEl && btn.__sjOrigLabel != null) btn.__sjLabelEl.textContent = btn.__sjOrigLabel;
  }

  /* A stale tag must never lock a former member out for good. The customer can
     declare that their membership was cancelled and the block is released for
     this session; the cart still clamps the membership to a single line. */
  function releaseBlock() {
    STATE.active = false;
    Array.prototype.forEach.call(document.querySelectorAll('[data-sj-vip-blocked]'), unmarkButton);
    document.dispatchEvent(new CustomEvent('sj:vip:released'));
    scan(document);
  }
  window.SJVipRelease = releaseBlock;

  document.addEventListener('click', function (ev) {
    var t = ev.target.closest('[data-sj-vip-reveal], [data-sj-vip-rejoin]');
    if (!t) return;
    if (STATE.inCart >= 1) { toast(LIMIT_MSG); return; }
    releaseBlock();
  });

  function scan(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;

    /* quantity controls next to a VIP line or a VIP form are always locked to 1 */
    var forms = root.querySelectorAll('form[action*="/cart/add"]');
    Array.prototype.forEach.call(forms, function (f) {
      var idf = f.querySelector('[name="id"]');
      if (!idf || !isVipId(idf.value)) return;
      f.setAttribute('data-sj-vip-form', '');
      var q = f.querySelector('[name="quantity"]');
      if (q) { q.value = '1'; q.setAttribute('max', '1'); if (q.type !== 'hidden') q.setAttribute('readonly', 'readonly'); }
      if (STATE.active || STATE.inCart >= 1) {
        Array.prototype.forEach.call(f.querySelectorAll('button[type="submit"],[name="add"]'), markButton);
      }
    });

    if (STATE.active || STATE.inCart >= 1) {
      Array.prototype.forEach.call(root.querySelectorAll('[data-sj-vip-quickbuy]'), function (b) {
        if (isVipId(b.getAttribute('data-variant-id'))) markButton(b);
      });
    }

    /* cart line for the membership - lock the stepper */
    Array.prototype.forEach.call(root.querySelectorAll('a[href*="/products/' + CFG.handle + '"]'), function (a) {
      var row = a.closest('[data-line-index], .cart-item, cart-items-component li, tr');
      if (!row) return;
      row.setAttribute('data-sj-vip-line', '');
      Array.prototype.forEach.call(row.querySelectorAll('input[type="number"], input[name="updates[]"], input[name*="quantity"]'), function (inp) {
        inp.setAttribute('max', '1');
        inp.setAttribute('readonly', 'readonly');
      });
      Array.prototype.forEach.call(row.querySelectorAll('button'), function (b) {
        var t = (b.getAttribute('aria-label') || b.className || '') + '';
        if (/increase|plus/i.test(t)) { b.disabled = true; b.setAttribute('aria-disabled', 'true'); }
      });
    });
  }

  /* --------------------------------------------- cart reconcile ------ */
  var syncing = false;
  function syncFromCart() {
    if (syncing) return;
    syncing = true;
    nativeFetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var order = [], total = 0, overLine = 0;
        (cart.items || []).forEach(function (it, i) {
          order.push(it.variant_id);
          if (isVipId(it.variant_id) || it.handle === CFG.handle) {
            total += it.quantity;
            if (it.quantity > 1) overLine = i + 1;
          }
        });
        CFG.cartLineVariants = order;
        STATE.inCart = total;

        if (overLine) {
          return nativeFetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ line: overLine, quantity: 1 })
          }).then(function () {
            toast(LIMIT_MSG);
            STATE.inCart = 1;
            document.dispatchEvent(new CustomEvent('sj:vip:clamped'));
          });
        }
      })
      .catch(function () {})
      .then(function () { syncing = false; scan(document); });
  }

  function boot() {
    scan(document);
    syncFromCart();
    readLiveMembership(true);
    /* re-check when the tab regains focus, so a membership bought in another
       tab or on another device is picked up before a second one is added */
    window.addEventListener('focus', function () { readLiveMembership(false); });
    window.addEventListener('pageshow', function () { syncFromCart(); readLiveMembership(false); });
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes && muts[i].addedNodes.length) { scan(document); break; }
      }
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();

  window.SJVip = {
    state: STATE,
    config: CFG,
    isVipVariant: isVipId,
    refreshFromCart: syncFromCart
  };
})();
